import { z } from 'zod';
import { defineEndpoint } from '../define';

/**
 * Publish a succeeded/published mobile build to Firebase App Distribution
 * testers (UCH-418). The build itself was uploaded by the adhoc workflow; this
 * sets release notes and distributes to the given tester groups.
 */
export const DistributeReleaseBodySchema = z
  .object({
    groupAliases: z.array(z.string().trim().min(1).max(200)).min(1).max(50),
    releaseNotes: z.string().max(16384),
  })
  .strict();
export type DistributeReleaseBody = z.infer<typeof DistributeReleaseBodySchema>;

export const distributeRelease = defineEndpoint({
  method: 'POST',
  path: '/v1/releases/:releaseId/distribute',
  params: z.object({ releaseId: z.string().uuid() }),
  query: z.object({}),
  body: DistributeReleaseBodySchema,
  response: z.object({
    /** One entry per configured platform whose build was found on FAD. */
    data: z.object({
      distributed: z.array(
        z.object({
          platform: z.enum(['android', 'ios']),
          fadReleaseName: z.string(),
          consoleUri: z.string(),
        }),
      ),
    }),
  }),
});
